<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/walletindex' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>钱包</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>提现记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item" id="auto-0">
          <span>提现时间</span>
          <el-date-picker
            v-model="filter.beginDate"
            type="datetime"
            placeholder="选择开始时间"
            :clearable="false"
            value-format="timestamp"
            :picker-options="pickerTime"
          >
          </el-date-picker>
          <span>-</span>
          <el-date-picker
            v-model="filter.endDate"
            type="datetime"
            placeholder="选择结束时间"
            default-time="23:59:59"
            :clearable="false"
            value-format="timestamp"
            :picker-options="pickerTime"
          >
          </el-date-picker>
        </div>
        <div class="toolbar-item" id="auto-1">
          <el-button type="primary" @click="screen">筛选</el-button>
        </div>
      </div>
    </div>
    <div class="table-custom-box" id="auto-2">
      <el-table :data="tableData.data" border>
        <el-table-column prop="serialNum" label="交易订单号" min-width="200"> </el-table-column>
        <el-table-column label="提现金额" min-width="120">
          <template v-slot="scope">
            <span class="font-orange">{{ scope.row.money | thousands(2) }}元</span>
          </template>
        </el-table-column>
        <el-table-column prop="bankcardInfo" label="提现到" min-width="180"> </el-table-column>
        <el-table-column prop="createDate" label="提现时间" min-width="160"> </el-table-column>
        <el-table-column prop="stateDesc" label="提现状态" min-width="100"> </el-table-column>
        <el-table-column prop="updateDate" label="预计到账时间" min-width="160"> </el-table-column>
        <el-table-column prop="memo" label="备注" min-width="130"> </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:2
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/wallet.new.api';
import { WUYI } from '@/api/common';
import dateLimit from '@/api/dateLimit';
export default {
  name: 'WithdrawLog',
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      tableData: {
        data: [],
        total: 0
      },
      filter: {
        beginDate: new Date(dateLimit.getThreeMonth()).getTime(),
        endDate: dateLimit.currentDayEnd.getTime(),
        chlType: '',
        taxChlType: null,
        taxCompanyId: ''
      },
      cache: {},
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      }
    };
  },
  created() {
    this.filter.chlType = this.$route.params.chlType;
    this.filter.taxChlType = this.$route.params.taxChlType || null;
    this.filter.taxCompanyId = this.$route.params.taxCompanyId;
    this.screen();
  },
  methods: {
    // 筛选
    screen() {
      if (!WUYI.checkDate(this.filter.beginDate, this.filter.endDate)) return;
      this.cache = { ...this.filter };
      this.currentPage = 1;
      this.axiosRequest();
    },
    //分页点击
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    axiosRequest() {
      let options = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.cache };
      axios.post(api.queryWithdrawList, options).then(res => {
        if (res.data.total == 0) {
          this.$message.warning('未查询到数据，请重新筛选');
        }
        this.tableData.data = res.data.data || [];
        this.tableData.total = res.data.total || 0;
      });
    }
  }
};
</script>
